// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  Fileupload,
} from './';

export default {
  path: 'fileupload',
  name: 'Fileupload',
  childRoutes: [
    { path: 'fileupload', name: 'Fileupload', component: Fileupload, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/fileupload/route.js